module.exports = __webpack_public_path__ + "static/media/404-monk_telemachus.73d2ab86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/404-monk_telemachus.jpg
// module id = 340
// module chunks = 0